import {  PlainDownArrow } from 'assests/GmsIcons';
import React, { useState, useEffect } from 'react';
import {SortableAttribute} from "../../types/sortconfig.types";

type AddAttributesPopupProps = {
    id?: string;
    attributes: any[];
    existingAttributes?: SortableAttribute[];
    onClose: () => void;
    onSave: (attributes: SortableAttribute[]) => void;
}
const AddAttributesPopup = ({ id, attributes, existingAttributes = [], onClose, onSave }: AddAttributesPopupProps) => {
    const baseId = id || 'add-attributes-popup';
    const [tempAttributes, setTempAttributes] = useState<SortableAttribute[]>([
        { id: '', name: '', label: '', dataType: '' },
        { id: '', name: '', label: '', dataType: '' },
        { id: '', name: '', label: '', dataType: '' }
    ]);
    useEffect(() => {
        if (existingAttributes.length > 0) {
            const initialAttributes = [...existingAttributes];
            while (initialAttributes.length < 3) {
                initialAttributes.push({ id: '', name: '', label: '', dataType: '' });
            }
            setTempAttributes(initialAttributes.slice(0, 3));
        }
    }, [existingAttributes]);
    const handleAttributeChange = (index: number, field: string, value: string) => {
        const updated = [...tempAttributes];
        if (field === 'attribute') {
            const selectedAttr = attributes.find(attr => attr.id === value);
            if (selectedAttr) {
                updated[index] = {
                    ...updated[index],
                    id: selectedAttr.id,
                    name: selectedAttr.name,
                    dataType: selectedAttr.datatype || selectedAttr.dataType || 'TEXT'
                };
            }
        } else if (field === 'dataType') {
            updated[index].dataType = value;
        } else if (field === 'label') {
            updated[index].label = value;
        }
        setTempAttributes(updated);
    };
    const handleSave = () => {
        const validAttributes = tempAttributes.filter(attr => attr.id && attr.name);
        onSave(validAttributes);
        onClose();
    };
    return (
        <div id={baseId} data-testid={baseId} className="tw-w-full tw-max-w-4xl">
            <div id={`${baseId}-content`} className="tw-p-6">
                {/* Attributes Table */}
                <div id={`${baseId}-table`} className="tw-border tw-border-solid tw-border-[#C9CCCF] tw-rounded tw-text-[#6D788C] tw-text-xs  tw-overflow-hidden">
                    {/* Header Row */}
                    <div id={`${baseId}-table-header`} className="tw-grid tw-grid-cols-3 tw-bg-[#F4F5F7] tw-border-[#C9CCCF] tw-border-b tw-border-solid">
                        <div id={`${baseId}-header-attribute`} className="tw-p-2 tw-font-medium tw-border-r tw-border-solid tw-border-[#C9CCCF]">Add Attribute</div>
                        <div id={`${baseId}-header-name`} className="tw-p-2 tw-font-medium tw-border-r tw-border-solid tw-border-[#C9CCCF]">Edit Attribute Name</div>
                        <div id={`${baseId}-header-datatype`} className="tw-p-2 tw-font-medium">Data Type</div>
                    </div>
                    {/* Attribute Rows */}
                    {tempAttributes.map((attr, index) => (
                        <div
                            key={index}
                            id={`${baseId}-row-${index}`}
                            data-testid={`${baseId}-row-${index}`}
                            className={`tw-grid tw-grid-cols-3 tw-bg-white ${
                                index < tempAttributes.length - 1 ? 'tw-border-b tw-border-solid tw-border-[#C9CCCF]' : ''
                            }`}
                        >
                            {/* Select Attribute Dropdown */}
                            <div id={`${baseId}-row-${index}-attribute-cell`} className="tw-p-2 tw-border-r tw-border-solid tw-border-[#C9CCCF]">
                                <div className="tw-relative">
                                    <select
                                        id={`${baseId}-row-${index}-attribute-select`}
                                        data-testid={`${baseId}-row-${index}-attribute-select`}
                                        value={attr.id}
                                        onChange={(e) => handleAttributeChange(index, 'attribute', e.target.value)}
                                        className="tw-appearance-none tw-block tw-w-full tw-px-3 tw-py-2 tw-bg-transparent tw-text-[#6D788C] tw-leading-tight focus:tw-outline-none focus:tw-bg-white tw-text-xs"
                                    >
                                        <option value="">Select Attribute</option>
                                        {attributes.map((attribute) => (
                                            <option key={attribute.id} value={attribute.id}>
                                                {attribute.name}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-px-2 tw-text-[#97A0AF]">
                                        <PlainDownArrow />
                                    </div>
                                </div>
                            </div>
                            {/* Edit Attribute Name Input */}
                            <div id={`${baseId}-row-${index}-name-cell`} className="tw-p-2 tw-border-r tw-border-solid tw-border-[#C9CCCF]">
                                <input
                                    id={`${baseId}-row-${index}-name-input`}
                                    data-testid={`${baseId}-row-${index}-name-input`}
                                    type="text"
                                    value={attr.label}
                                    onChange={(e) => handleAttributeChange(index, 'label', e.target.value)}
                                    placeholder="custom name"
                                    className='tw-w-full tw-text-[#6D788C] tw-font-medium tw-text-xs tw-px-3 tw-py-2 tw-bg-transparent focus:tw-outline-none tw-placeholder-[#6D788C]'
                                />
                            </div>
                            {/* Data Type text */}
                            <div id={`${baseId}-row-${index}-datatype-cell`} className="tw-px-2 tw-py-4 tw-text-xs">
                                <label id={`${baseId}-row-${index}-datatype-label`}>
                                    {attr.dataType}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Action Buttons */}
                <div id={`${baseId}-actions`} className="tw-flex tw-justify-end tw-gap-3 tw-mt-8">
                    <button
                        id={`${baseId}-cancel-btn`}
                        data-testid={`${baseId}-cancel-btn`}
                        onClick={onClose}
                        className="popup-button-outline"
                    >
                        Cancel
                    </button>
                    <button
                        id={`${baseId}-done-btn`}
                        data-testid={`${baseId}-done-btn`}
                        onClick={handleSave}
                        className="popup-button-filled"
                    >
                        Done
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddAttributesPopup;